<template>
    <div id="myCarousel" class="carousel slide">
      <div class="carousel-indicators">
        <button
          v-for="(item, index) in slides"
          :key="index"
          type="button"
          :data-bs-target="'#myCarousel'"
          :data-bs-slide-to="index"
          :class="{ active: index === 0 }"
          :aria-current="index === 0 ? 'true' : null"
          :aria-label="'Slide ' + (index + 1)"
          
        ></button>
      </div>
      <div class="carousel-inner">
        <div
          v-for="(item, index) in slides"
          :key="index"
          :class="['carousel-item', { active: index === 0 }]"
        >
          <a :href="item.link">
            <img class="d-block w-100" :src="item.image" :alt="item.title" />
          </a>
          <div class="container">
            <div
              class="carousel-caption"
              :class="{
                'text-start': item.align === 'left',
                'text-center': item.align === 'center',
                'text-end': item.align === 'right',
              }"
            >
              <h3 v-if="item.title">{{ item.title }}</h3>
              <p v-if="item.description">{{ item.description }}</p>
              <p v-if="item.buttonText">
                <a class="btn btn-lg btn-primary" :href="item.buttonLink">{{
                  item.buttonText
                }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "Slider",
    props: {
      slides: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
  };
  </script>
  
  <style scoped>
  .carousel-item img {
    max-height: 500px;
    object-fit: cover;
  }
  </style>
  